import { useCallback, useRef } from 'react'

import { useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import { ConversationFooter } from './components/ConversationFooter'
import messages from './messages'
import { useGlobalCommandView } from './useGlobalCommandView'
import { GlobalCommandModal } from '../../components/GlobalCommandModal'
import { GetGlobalSearchResultsPresenter } from '../../features/get-global-search-results/presenters/GetGlobalSearchResultsPresenter'
import { useGlobalSearchHotkey } from '../../hooks/useGlobalSearchHotkey'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'

export const GlobalCommandView = () => {
  const intl = useProcurifyIntl()
  const { isOpen, open, close } = useGlobalSearch()
  const {
    data,
    methods: { startConversation, endConversation },
    states,
  } = useGlobalCommandView()
  const searchInputRef = useRef<HTMLInputElement>(null)
  const DATA_2061_GUIDED_INTAKE_ORDERS = useFeatureFlag(
    'DATA_2061_GUIDED_INTAKE_ORDERS'
  )

  useGlobalSearchHotkey(open)

  const focusSearchInput = () => {
    searchInputRef.current?.focus()
  }

  const handleClose = useCallback(() => {
    endConversation()
    close()
  }, [endConversation, close])

  const isConversation = DATA_2061_GUIDED_INTAKE_ORDERS && states.isConversation

  return (
    <GlobalCommandModal
      isOpen={isOpen}
      onClose={handleClose}
      onEntered={focusSearchInput}
      isConversation={isConversation}
      title={intl.formatMessage(messages.conversationTitle)}
      footer={isConversation ? <ConversationFooter /> : undefined}
    >
      {isConversation ? (
        // Placeholder body for the Guided Intake branch. Follow-up PRs replace
        // this with the ChatStream + RunConversationTurnPresenter once the GI
        // features ship.
        <div data-testid='global-command-conversation'>
          {data.conversationId}
        </div>
      ) : (
        <GetGlobalSearchResultsPresenter
          key={isOpen ? 'open' : 'closed'}
          inputRef={searchInputRef}
          onClose={handleClose}
          onHandoff={
            DATA_2061_GUIDED_INTAKE_ORDERS ? startConversation : undefined
          }
        />
      )}
    </GlobalCommandModal>
  )
}
